var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.28 14.34a.747.747 0 0 1-1.06 0l-4.235-4.235a1.125 1.125 0 0 1 0-1.59l.53-.53a1.125 1.125 0 0 1 1.591 0l2.644 2.643 7.144-7.143a1.125 1.125 0 0 1 1.59 0l.53.53a1.125 1.125 0 0 1 0 1.59L7.28 14.341Z",
  fill: "#26890D"
})));
export default SvgGreenCheck;